import React from 'react'
import { convertSingleValueOnly, convertSingleUnit, formatDateTimeString } from '../../utils/commonUtils'
import usIcon from '../../utils/icons/us.svg';
import japanIcon from '../../utils/icons/japan.svg';
import chinaIcon from '../../utils/icons/china.svg';
import { getCountryName } from '../../utils/commonUtils'


const FinancialTableRow = ({columnName, value, unit, convertValue=true, isCountry=false, isExchange=false, convertDate=false}) => {
    const getCountryIcon = (country) => {
        const countryIcons = {
            US: usIcon,
            JP: japanIcon,
            CN: chinaIcon,
        };
        return countryIcons[country] || null;
    };
    
    const getExchangeIcon = (exchange) => {
        const countryIcons = {
            NASDAQ: usIcon,
            NYSE: usIcon,
            JPX: japanIcon,
            SHZ: chinaIcon,
            SHH: chinaIcon,
        };
        return countryIcons[exchange] || null;
    }


    const CountryIcon = ({ country }) => {
        const iconFile = getCountryIcon(country);
        // countryコードが不明な場合の処理
        if (!iconFile) {
            return;
        }
    
        // アイコンを表示
        return <img src={iconFile} alt={`${country} flag`} className='w-[30px] h-[auto] pb-1' />;
    };
    
    const ExchangeIcon = ({ exchange }) => {
        const iconFile = getExchangeIcon(exchange);
        if (!iconFile) {
            return;
        }
    
        // アイコンを表示
        return <img src={iconFile} alt={`${exchange} flag`} className='w-[30px] h-[auto] pb-1' />;
    };
    
    return (
        <div className="financial-table-row">
            <span className="financial-table-label">{columnName}</span>
            { isCountry ?
                <span className='flex items-center'>
                    <CountryIcon country={value} /> <span className='ml-2 mr-1'>{getCountryName(value)}</span>
                </span>
            : isExchange ?  
                <span className="flex items-center">
                    <ExchangeIcon exchange={value} /> 
                    <span className="ml-2 mr-1">{value}</span>
                </span>
            :
                <span className="financial-table-value">
                    {
                    (unit === "人") ? 
                    <span className="value">{value ? value.toLocaleString() : '-'}</span>
                    : 
                    (convertDate && value) ?
                    <span className="value">{formatDateTimeString(value, 'YYYY年m月d日')}</span>
                    :
                    <span className="value">{convertValue ? convertSingleValueOnly(value) : value}</span>
                    }
                    <span className="unit">{convertValue && convertSingleUnit(value)}{unit}</span>
                </span>
            }
        </div>
    )
}

export default FinancialTableRow